import { homeRouter } from '@/features/home';
import { middlePageOpenAppRouter } from '@/features/middle-page-open-app/middle-page-open-app.router';
import { workbenchAppRouter } from '@/features/workbench-app/workbench-app.router';
import { middlePageLogoutRouter } from '@/features/middle-page-logout/middle-page-logout.router';
import { middlePageNetworkErrorRouter } from '@/features/middle-page-network-error/middle-page-network-error.router';
import { middlePageUrlBlockRouter } from '@/features/middle-page-url-block/middle-page-url-block.router';
import type { RouteRecordRaw } from 'vue-router';

/** 路由数组 */
export const routes: RouteRecordRaw[] = [
  ...homeRouter,
  ...middlePageOpenAppRouter,
  ...workbenchAppRouter,
  ...middlePageLogoutRouter,
  ...middlePageNetworkErrorRouter,
  ...middlePageUrlBlockRouter,
];
